import closeIcon from '../assets/login/close-icon.png';
import countryFlagIcon from '../assets/login/countryflag.png';
import editIcon from '../assets/login/edit-icon.png';
import funnelIcon from '../assets/login/funnel-icon.png';
import inputCloseIcon from '../assets/login/input-close-icon.png';
import retryIcon from '../assets/login/retry.png';
import arrowRightGrayIcon from '../assets/login/right-icon-gray.png';
import arrowRightWhiteIcon from '../assets/login/right-icon-white.png';
import sendIcon from '../assets/login/send-icon.png';
import tipsErrorIcon from '../assets/login/tips-error.png';
import inputTipsNormalIcon from '../assets/login/tips-normal.png';
import inputTipsErrorIcon from '../assets/login/tips-warning.png';
import toastWarnIcon from '../assets/login/toast-warning.png';
import verifySuccessIcon from '../assets/login/verify-success.png';

export const SHIELD_IMAGE =
    'https://s3-us01.didiglobal.com/ibg-fintech-marketing-team-v3/marketing-svelte/login-page/images/shield-icon.png';
export const PICTURE_LOADING_IMAGE =
    'https://s3-us01.didiglobal.com/ibg-fintech-marketing-team-v3/marketing-svelte/login-page/images/loading-2.gif';
export const COUNTRY_FLAG_IMAGE = countryFlagIcon;
export const INPUT_CLOSE_ICON = inputCloseIcon;
export const INPUT_TIPS_NORMAL_ICON = inputTipsNormalIcon;
export const INPUT_TIPS_ERROR_ICON = inputTipsErrorIcon;
export const ARROW_RIGHT_WHITE_ICON = arrowRightWhiteIcon;
export const ARROW_RIGHT_GRAY_ICON = arrowRightGrayIcon;
export const RETRY_ICON = retryIcon;
export const TOAST_WARN_ICON = toastWarnIcon;
export const EDIT_ICON = editIcon;
export const SEND_ICON = sendIcon;
export const CLOSE_ICON = closeIcon;
export const TIPS_ERROR_ICON = tipsErrorIcon;
export const FUNNEL_ICON = funnelIcon;
export const VERIFY_SUCCESS_ICON = verifySuccessIcon;
